module.exports = __webpack_public_path__ + "media/1x1/gr-0bed56a8.svg";